import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { eldMalfunctionsState } from './eldMalfunctionsState';
import { EldMalfunctionsState } from '../types';
import { RootState } from 'store/store';

export const eldMalfunctionsSlice = createSlice({
  name: 'eldMalfunctions',
  initialState: eldMalfunctionsState,
  reducers: {
    setEldMalfunctions(
      state,
      action: PayloadAction<EldMalfunctionsState['eldMalfunctions']>,
    ) {
      state.eldMalfunctions = action.payload;
    },
    setEldMalfunctionsReportsData(
      state,
      action: PayloadAction<EldMalfunctionsState['eldMalfunctionsReportData']>,
    ) {
      state.eldMalfunctionsReportData = action.payload;
    },
    setSortBy(state, action: PayloadAction<EldMalfunctionsState['sortBy']>) {
      state.sortBy = action.payload;
    },
    setSortField(
      state,
      action: PayloadAction<EldMalfunctionsState['sortField']>,
    ) {
      state.sortField = action.payload;
    },
    setEvent(state, action: PayloadAction<EldMalfunctionsState['event']>) {
      state.event = action.payload;
    },
    setStatus(state, action: PayloadAction<EldMalfunctionsState['status']>) {
      state.status = action.payload;
    },
    setDriver(state, action: PayloadAction<EldMalfunctionsState['driver']>) {
      state.driver = action.payload;
    },
    setVehicle(state, action: PayloadAction<EldMalfunctionsState['vehicles']>) {
      state.vehicles = action.payload;
    },
    setDateRange(
      state,
      action: PayloadAction<EldMalfunctionsState['dateRange']>,
    ) {
      state.dateRange = action.payload;
    },
    setRemarksKeyword(
      state,
      action: PayloadAction<EldMalfunctionsState['remarksKeyword']>,
    ) {
      state.remarksKeyword = action.payload;
    },
    setMalfunctionsAndDiagnostics(
      state,
      action: PayloadAction<EldMalfunctionsState['malfunctionsAndDiagnostics']>,
    ) {
      state.malfunctionsAndDiagnostics = action.payload;
    },
    setRowsPerPage(
      state,
      action: PayloadAction<EldMalfunctionsState['limit']>,
    ) {
      state.limit = action.payload;
    },
    setPageIndex(state, action: PayloadAction<EldMalfunctionsState['offset']>) {
      state.offset = action.payload;
    },
    setTotalRecordCounts(
      state,
      action: PayloadAction<EldMalfunctionsState['totalRecordCount']>,
    ) {
      state.totalRecordCount = action.payload;
    },
    setDocumentType(
      state,
      action: PayloadAction<EldMalfunctionsState['documentType']>,
    ) {
      state.documentType = action.payload;
    },
    setPaperOrientation(
      state,
      action: PayloadAction<EldMalfunctionsState['paperOrientation']>,
    ) {
      state.paperOrientation = action.payload;
    },
    setRequestPendingTo(
      state,
      action: PayloadAction<EldMalfunctionsState['isRequestPending']>,
    ) {
      state.isRequestPending = action.payload;
    },
    setToggleExportFileModal(
      state,
      action: PayloadAction<EldMalfunctionsState['isToggleExportFileModal']>,
    ) {
      state.isToggleExportFileModal = action.payload;
    },
    setExportDataRequestPendingTo(
      state,
      action: PayloadAction<EldMalfunctionsState['isExportDataRequestPending']>,
    ) {
      state.isExportDataRequestPending = action.payload;
    },
    setVehicleFilterMenuClosed(
      state,
      action: PayloadAction<EldMalfunctionsState['isVehicleFilterMenuClosed']>,
    ) {
      state.isVehicleFilterMenuClosed = action.payload;
    },
    setDataReset(state) {
      return {
        ...state,
        ...eldMalfunctionsState,
      };
    },
  },
});

/* ------- ACTION CREATORS ------- */
export const { actions: eldMalfunctionActions } = eldMalfunctionsSlice;

/* ------- STATE SELECTORS ------- */
export const selectEldMalfunctions = (state: RootState) =>
  state.eldMalfunctions;

export default eldMalfunctionsSlice.reducer;
